import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--skill-sheet-build-form"
export default class extends Controller {
  static targets = ["jobHistoryHiddenFields"];
  static values = {
    index: Number,
  };
  connect() {
    CsrfToken(this);
    TurboStreamHeaders(this);
  }

  submit(e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "resume_skill_sheet[id]",
      document.querySelector(
        "[data-resumin--skill-sheet-build-form-target='skillSheetId']"
      ).value
    );
    this.jobHistoryHiddenFieldsTarget
      .querySelectorAll('input[type="hidden"]')
      .forEach((input) => {
        if (
          input.dataset["resumin-SkillSheetBuildFormTarget"] ===
          "jobHistoryDestroy"
        ) {
          return;
        }
        formData.append(input.name, input.value);
      });

    formData.append("job_history_index", this.indexValue);
    fetch("/skill_sheet_job_history/build_form", {
      method: "POST",
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeadersValue,
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
}
